<template>
  <div class="main">
    <c-panel>
      <form-fornecedor :paramId="$route.params.id" v-on:onSubmitFornecedor="onSubmitFornecedor"></form-fornecedor>
    </c-panel>
  </div>
</template>
<script>
import formFornecedor from "./form"

export default {
  methods: {
    onSubmitFornecedor () {
      this.$router.push('/admin/financeiro/fornecedor')
    }
  },
  components: { formFornecedor }
}
</script>

